/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreditCardPaymentRequestModel,
  CreditCardPaymentResponseModel,
  ErrorCodesModel,
  MobilePaymentRequestModel,
  StripePaymentChargeStatusResponseModel,
  StripePaymentStatusResponseModel,
} from '../models/index';
import {
    CreditCardPaymentRequestModelFromJSON,
    CreditCardPaymentRequestModelToJSON,
    CreditCardPaymentResponseModelFromJSON,
    CreditCardPaymentResponseModelToJSON,
    ErrorCodesModelFromJSON,
    ErrorCodesModelToJSON,
    MobilePaymentRequestModelFromJSON,
    MobilePaymentRequestModelToJSON,
    StripePaymentChargeStatusResponseModelFromJSON,
    StripePaymentChargeStatusResponseModelToJSON,
    StripePaymentStatusResponseModelFromJSON,
    StripePaymentStatusResponseModelToJSON,
} from '../models/index';

export interface GetCreditCardPaymentRequest {
    xComiciUserTokenRequired: string;
}

export interface GetCreditCardPaymentChargeRequest {
    xComiciUserTokenRequired: string;
    stripePaymentIntentId: string;
}

export interface PostCreditCardPaymentRequest {
    xComiciUserTokenRequired: string;
    creditCardPaymentRequestModel: CreditCardPaymentRequestModel;
}

export interface PostMobilePaymentRequest {
    xComiciUserTokenRequired: string;
    mobilePaymentRequestModel: MobilePaymentRequestModel;
}

/**
 * 
 */
export class PaymentStripeApi extends runtime.BaseAPI {

    /**
     * このAPIは通常Stripe側からWebhookによって処理完了が通知されるクレカ3DS決済処理で、通知が来ない場合に決済状態を取得するためのリカバリ用APIです。 決済開始から24時間以内でコインチャージが完了になっていないクレジットカード3Dセキュア決済の状態をStripeから取得し、決済が完了している場合、コミチ側でチャージ処理を行います。
     * クレカ3DS決済状態取得
     */
    async getCreditCardPaymentRaw(requestParameters: GetCreditCardPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripePaymentStatusResponseModel>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling getCreditCardPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/payment/stripe/creditcardPayment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripePaymentStatusResponseModelFromJSON(jsonValue));
    }

    /**
     * このAPIは通常Stripe側からWebhookによって処理完了が通知されるクレカ3DS決済処理で、通知が来ない場合に決済状態を取得するためのリカバリ用APIです。 決済開始から24時間以内でコインチャージが完了になっていないクレジットカード3Dセキュア決済の状態をStripeから取得し、決済が完了している場合、コミチ側でチャージ処理を行います。
     * クレカ3DS決済状態取得
     */
    async getCreditCardPayment(requestParameters: GetCreditCardPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripePaymentStatusResponseModel> {
        const response = await this.getCreditCardPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * クレジットカード決済後のコインチャージ処理の状態を取得します。 最長20秒Stripe側の決済終了通知またはコミチ側のコインチャージ処理の完了を待ちます。 タイムアウトの場合は処理中の状態を返却します。 決済処理エラーまたはチャージ処理失敗の場合は失敗の状態を返却します。
     * クレカ3DS決済コインチャージ状態取得
     */
    async getCreditCardPaymentChargeRaw(requestParameters: GetCreditCardPaymentChargeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripePaymentChargeStatusResponseModel>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling getCreditCardPaymentCharge.');
        }

        if (requestParameters.stripePaymentIntentId === null || requestParameters.stripePaymentIntentId === undefined) {
            throw new runtime.RequiredError('stripePaymentIntentId','Required parameter requestParameters.stripePaymentIntentId was null or undefined when calling getCreditCardPaymentCharge.');
        }

        const queryParameters: any = {};

        if (requestParameters.stripePaymentIntentId !== undefined) {
            queryParameters['stripePaymentIntentId'] = requestParameters.stripePaymentIntentId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/payment/stripe/creditcardPayment/charge`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripePaymentChargeStatusResponseModelFromJSON(jsonValue));
    }

    /**
     * クレジットカード決済後のコインチャージ処理の状態を取得します。 最長20秒Stripe側の決済終了通知またはコミチ側のコインチャージ処理の完了を待ちます。 タイムアウトの場合は処理中の状態を返却します。 決済処理エラーまたはチャージ処理失敗の場合は失敗の状態を返却します。
     * クレカ3DS決済コインチャージ状態取得
     */
    async getCreditCardPaymentCharge(requestParameters: GetCreditCardPaymentChargeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripePaymentChargeStatusResponseModel> {
        const response = await this.getCreditCardPaymentChargeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Stripe経由でクレジットカード決済をします。3Dセキュア認証が必要な場合は、3Dセキュア認証を行うための情報を返却します。3Dセキュア認証が不要な場合は、決済完了のレスポンスを返却します。 
     * クレカ決済
     */
    async postCreditCardPaymentRaw(requestParameters: PostCreditCardPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreditCardPaymentResponseModel>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling postCreditCardPayment.');
        }

        if (requestParameters.creditCardPaymentRequestModel === null || requestParameters.creditCardPaymentRequestModel === undefined) {
            throw new runtime.RequiredError('creditCardPaymentRequestModel','Required parameter requestParameters.creditCardPaymentRequestModel was null or undefined when calling postCreditCardPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/payment/stripe/creditcardPayment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreditCardPaymentRequestModelToJSON(requestParameters.creditCardPaymentRequestModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreditCardPaymentResponseModelFromJSON(jsonValue));
    }

    /**
     * Stripe経由でクレジットカード決済をします。3Dセキュア認証が必要な場合は、3Dセキュア認証を行うための情報を返却します。3Dセキュア認証が不要な場合は、決済完了のレスポンスを返却します。 
     * クレカ決済
     */
    async postCreditCardPayment(requestParameters: PostCreditCardPaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreditCardPaymentResponseModel> {
        const response = await this.postCreditCardPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Stripe経由でモバイル決済(ApplePay, GooglePay)を行います。 
     * モバイル決済
     */
    async postMobilePaymentRaw(requestParameters: PostMobilePaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xComiciUserTokenRequired === null || requestParameters.xComiciUserTokenRequired === undefined) {
            throw new runtime.RequiredError('xComiciUserTokenRequired','Required parameter requestParameters.xComiciUserTokenRequired was null or undefined when calling postMobilePayment.');
        }

        if (requestParameters.mobilePaymentRequestModel === null || requestParameters.mobilePaymentRequestModel === undefined) {
            throw new runtime.RequiredError('mobilePaymentRequestModel','Required parameter requestParameters.mobilePaymentRequestModel was null or undefined when calling postMobilePayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xComiciUserTokenRequired !== undefined && requestParameters.xComiciUserTokenRequired !== null) {
            headerParameters['X-Comici-User-Token-Required'] = String(requestParameters.xComiciUserTokenRequired);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("contentApiKey", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/payment/stripe/mobilePayment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MobilePaymentRequestModelToJSON(requestParameters.mobilePaymentRequestModel),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stripe経由でモバイル決済(ApplePay, GooglePay)を行います。 
     * モバイル決済
     */
    async postMobilePayment(requestParameters: PostMobilePaymentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postMobilePaymentRaw(requestParameters, initOverrides);
    }

}
